import { Box, Grid } from '@mui/material';

import ModalTrigger from '../Common/ModalTrigger';

import csv8 from '../../Data/MANCP/FoodProduct/MANCP-Number-of-different-pesticides-found-in-each-animal-food-group.csv';

import GradientColumnsChart from '../Charts/GradientColumnsChart';

const PesticideResiduesResults = (props) => {
	return (
		<Grid
			item
			container
			direction='column'
			sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }}
			alignContent='center'
		>
			<Grid
				item
				xs
				sx={{
					paddingLeft: { xs: '24px', sm: '24px', md: '24px' },
					paddingRight: { xs: '45px', sm: '45x', md: '24px' },
					paddingBottom: { xs: '24px', sm: '24px', md: '24px' }
				}}
				className='nine-one'
			>
				<Box className='nine-one-inner'>
					<h3>Results for animal products</h3>
					<p className='paragraph'>
						A total of 19,995 samples of animal products were reported. The results showed that 18,614 samples were free of quantifiable residues (93.1% vs 90% in 2023) while 1,381 samples (6.9% vs 9.2% in 2023) contained pesticides in quantifiable concentrations. MRL exceedances were identified in 102 samples (0.5% vs 0.8% 2023), of which 48 (0.2%) were deemed non-compliant when measurement uncertainty was taken into account.
					</p>
					<p className='paragraph'>
						The animal food groups with the highest number of different pesticides detected were muscle (38 pesticides), liver (35 pesticides), and honey and other apicultural products (31 pesticides).
					</p>
					<p className='paragraph'>
						The pesticide with a higher quantification rate was copper (55%).
					</p>
				</Box>
			</Grid>
			<Grid
				item
				xs
				p={3}
				className='nine-two'
				justifyContent='center'
				alignItems='center'
			>
				<GradientColumnsChart csv={csv8} title='Number of different pesticides found in each animal food group'/>
			</Grid>
			<Grid
				item
				xs
				sx={{
					paddingLeft: { xs: '24px', sm: '24px', md: '24px' },
					paddingRight: { xs: '45px', sm: '45x', md: '24px' },
					paddingBottom: { xs: '24px', sm: '24px', md: '24px' }
				}}
			>
				<Box className='chartInfoTitle'>
					<p>
						”Honey” and “Wild animals” refer to “Honey and other apicultural
						products” and “Wild terrestrial vertebrate animals”, respectively.
					</p>
				</Box>
			</Grid>
		</Grid>
	);
};

export default PesticideResiduesResults;
